import Store from "../Redux/Store";
/**
 * Hook to check whether any contract has a given family (default: "SANTE").
 *
 * @param {Array} profiles - Array of profile objects (expected shape: { value: { contracts: [...] } }).
 * @param {string} family - Contract family to look for. Defaults to "SANTE".
 * @param {Object} options - Optional settings.
 * @param {boolean} options.firstOnly - If true, only checks the first profile's contracts (preserves original function behavior).
 * @returns {boolean} true if a contract with the given family exists, otherwise false.
 */
export function useHasContractFamily(family = "SANTE", { firstOnly = false } = {}) {
  const profiles = Store.getState().profile.profile;
            if (!profiles || profiles.length === 0) {
                return false;
            }
        if (!Array.isArray(profiles) || profiles.length === 0) return false;

        if (firstOnly) {
            const contracts = profiles[0]?.value?.contracts;
            if (!Array.isArray(contracts) || contracts.length === 0) return false;
            return contracts.some((contract) => contract.family === family);
        }

        return profiles.some((p) => {
            const contracts = p?.value?.contracts;
            return Array.isArray(contracts) && contracts.some((contract) => contract.family === family);
        });
}

export default useHasContractFamily;